module.exports = __webpack_public_path__ + "static/img/cindy.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coaches/cindy.jpg
// module id = d6xv
// module chunks = 0